import React from 'react';
import styled from 'styled-components';

const FooterStyles = styled.footer`
  display: flex;
  width: 100%;
  flex: 0 0 auto;
  flex-direction: column;
  align-items: flex-start;
  gap: 3px;
  padding: 8px 2px 4px;
  border-top: 1px solid #d8dee8;
  color: #657186;
  font-size: 0.82rem;
  line-height: 1.3;
  min-height: 100px;

  .source-label {
    color: #394458;
    font-weight: 700;
  }
`;

export default function Footer() {
  return (
    <FooterStyles>
      <div>
        <span className="source-label">Source:</span>{' '}
        <span>Jobs and Skills Australia</span>
      </div>
      <div>Note: nec refers to not elsewhere classified</div>
    </FooterStyles>
  );
}
